import React, { useState } from 'react';
import SEO from './SEO';

type OpsPayload = {
  mailbox?: { blockers?: string[]; dailyCap?: number };
  checkout_live?: boolean;
  owner_price_decision?: string;
  emails_sent?: number;
  partners?: {
    partners?: number;
    qualified?: number;
    copy_qa?: number;
    no_public_contact?: number;
    send_ready?: number;
    accepted?: number;
    sequence_messages?: number;
    lifecycle_tasks_queued?: number;
    rows?: Array<{
      display_name: string;
      lifecycle_state: string;
      contact_state: string;
      has_named_contact: boolean;
      invite_accepted: boolean;
    }>;
  };
};

const GrowthOps: React.FC = () => {
  const [secret, setSecret] = useState('');
  const [data, setData] = useState<OpsPayload | null>(null);
  const [error, setError] = useState('');

  const load = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    const response = await fetch('/api/growth-ops', {
      headers: { Authorization: `Bearer ${secret}` },
    });
    if (!response.ok) {
      setError('Unauthorized or unavailable.');
      setData(null);
      return;
    }
    setData(await response.json());
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <SEO title="ClubIQ growth ops" />
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow p-6">
        <h1 className="text-2xl font-bold mb-2">Growth ops</h1>
        <p className="text-gray-600 mb-4">
          Counts only. No golfer emails, no partner emails, no secrets displayed from the server.
        </p>
        <form onSubmit={load} className="flex gap-3 mb-6">
          <input
            type="password"
            value={secret}
            onChange={(event) => setSecret(event.target.value)}
            placeholder="Metrics secret"
            className="flex-1 border rounded-xl px-4 py-2"
          />
          <button type="submit" className="bg-green-700 text-white rounded-xl px-4 py-2 font-semibold">
            Load
          </button>
        </form>
        {error && <p className="text-red-700 mb-4">{error}</p>}
        {data && (
          <div className="space-y-4">
            <p>Emails sent: {data.emails_sent ?? 0}</p>
            <p>Checkout live: {data.checkout_live ? 'yes' : 'no'}</p>
            <p>Mailbox blockers: {(data.mailbox?.blockers || []).join(', ') || 'none listed'}</p>
            <p>Price decision: {data.owner_price_decision}</p>
            <p>
              Partners {data.partners?.partners} · COPY_QA {data.partners?.copy_qa} · no public contact{' '}
              {data.partners?.no_public_contact} · SEND_READY {data.partners?.send_ready} · accepted{' '}
              {data.partners?.accepted} · queued lifecycle {data.partners?.lifecycle_tasks_queued ?? 0}
            </p>
            <table className="w-full text-left text-sm">
              <thead>
                <tr>
                  <th className="py-2">Partner</th>
                  <th>Lifecycle</th>
                  <th>Contact</th>
                  <th>Named</th>
                  <th>Accepted</th>
                </tr>
              </thead>
              <tbody>
                {(data.partners?.rows || []).map((row) => (
                  <tr key={row.display_name} className="border-t">
                    <td className="py-2">{row.display_name}</td>
                    <td>{row.lifecycle_state}</td>
                    <td>{row.contact_state}</td>
                    <td>{row.has_named_contact ? 'yes' : 'no'}</td>
                    <td>{row.invite_accepted ? 'yes' : 'no'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default GrowthOps;
